import { createSelector } from '@reduxjs/toolkit';

export const getExternalPayoutsState = (state) => state.externalPayouts;

export const getExternalPayouts = createSelector(
  getExternalPayoutsState,
  (payoutsState) => payoutsState.data,
);
